<template>
  <div>
    <!-- ページヘッダー -->
    <div class="container-fluid page-head-wrap">
      <div class="container page-head">
        <h3 class="h4 text-center">
          <router-link :to="{ name: 'top', params: {} }">
            <i class="fa fa-chevron-left back-icon" aria-hidden="true"></i>
          </router-link>
          <b><trans-text i18nKey="ui[2][1]"/></b>
        </h3>
      </div>
    </div>

    <div class="container">
      <div class="row">
        <div class="col-12 offset-lg-2 col-lg-8">
          <div class="alert alert-danger mt-3" role="alert" v-if="apiErrorI18nKey">
            <b><trans-text :i18nKey="apiErrorI18nKey"/></b>
          </div>
          <!-- 入力フォーム -->
          <page-form @tryForm="tryForm"></page-form>

          <!-- 画面遷移UI -->
          <div class="row text-center">
            <div class="offset-1 offset-sm-2 offset-md-3 col-10 col-sm-8 col-md-6">
              <div class="my-4">
                <h3 class="h6 font-size-1 mb-1">
                  <trans-text i18nKey="ui[2][12]"/>
                </h3>
                <router-link tag="button" class="btn w-100 btn-lg btn-danger" :to="{ name: 'demo-login', params:{} }">
                  <trans-text i18nKey="ui[2][13]"/>
                </router-link>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  /** @link MyNamespace/title */

  import {dd,store,app} from 'systems/imports'

  import PageForm from 'page/partials/DemoSignup/PageForm.vue'
  import DemoRegister from 'processor/DemoRegister'

  export default {
    name:"demoSignup",
    components: {
      PageForm,
    },
    data () {
      return {
        apiErrorI18nKey:null
      }
    },
    created(){
    },
    methods:{
      tryForm(input) {
        DemoRegister.provisionalRegister(input)
          .then((res)=>{
            if(res.status === "ng"){
              this.apiErrorI18nKey = res.apiErrorI18nKey
              return
            }
            store.set("provisionalUser",res.data.user)
            this.$router.push({ name: 'verify', params: {}})
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// DemoSignup.vue?1acf8e02